export const TOGGLE_QUALIFICATION_SIDE_BAR = "TOGGLE_QUALIFICATION_SIDE_BAR";
export const SET_QUALIFICATION_SIDE_BAR_SELECTION = "SET_QUALIFICATION_SIDE_BAR_SELECTION";
